<template>
  <div class="container">
    <div class="columns">
      <div class="column col-8 col-md-12">
      <div class="bg-secondary text-center">
      <p>Every transaction is encrypted and secured. <i class="fa fa-lock" aria-hidden="true"></i></p>
      </div>
      <form>
        <div class="form-group">
        
          <label class="form-label text-bold">Name</label>
          <input v-model="name" class="form-input" type="text" placeholder="Jane Doe" />

          <label class="form-label text-bold">Email</label>
          <input v-model="email" class="form-input" type="email" />

          <label class="form-label text-bold">Card</label>
          <div id="card-element" class="form-input card-input"><!-- a Stripe Element will be inserted here. --></div>

          <label class="form-label text-bold">Amount</label>
          <div class="input-group">
            <span class="input-group-addon">$</span>
            <input v-model.number="amount" type="number" class="form-input" placeholder="100">
          </div>
          <button class="btn btn-primary" @click.prevent="submit" :class="{loading: loading}">Pay Now</button>
          <span v-if="error" class="label label-error">😤 {{error}}</span>
          <span v-if="success" class="label label-success">😀 Success</span>
        
        </div>
      </form>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import utils from '@/components/utils'
export default {
  name: 'pay',
  mixins: [utils],
  data () {
    return {
      stripeKey: null,
      stripe: null,
      card: null,
      amount: null,
      name: '',
      email: '',
      error: '',
      success: false,
      loading: false
    }
  },
  created: function () {
    this.$root.$data.pageTitle = 'Payment'
  },
  mounted: function () {
    axios.get('/api/stripepk').then(res => {
      if (res.status === 200) {
        this.stripeKey = res.data
        this.mountStripe()
      }
    })
  },
  methods: {
    mountStripe: function () {
      const stripe = window.Stripe(this.stripeKey)
      const elements = stripe.elements()
      const options = {
        base: 'form-input',
        hidePostalCode: true,
        style: {
          base: {
            color: '#222222',
            fontFamily: '"Open Sans", sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '13px'
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        }
      }
      const card = elements.create('card', options)

      card.mount('#card-element')
      card.addEventListener('change', ({error}) => {
        this.error = error ? error.message : ''
      })

      this.stripe = stripe
      this.card = card
    },
    submit: async function () {
      if (this.loading || this.amount <= 0) return
      this.success = false
      this.loading = true
      const {token, error} = await this.stripe.createToken(this.card)

      if (error) {
        this.error = error.message
        this.loading = false
      } else {
        axios.post('/api/charge', {
          token: token.id,
          amount: parseInt(this.amount * 100),
          name: this.name,
          email: this.email
        })
        .then(res => {
          this.loading = false
          if (res.status === 200) {
            this.success = true
            this.card.clear()
            this.amount = null
            this.error = ''
            this.name = ''
            this.email = ''
            utils.methods.delay(5000, () => { this.success = false })
          }
        })
        .catch(e => {
          this.loading = false
          this.error = e.response.data.message
        })
      }
    }
  }
}
</script>

<style scoped>
.StripeElement--focus {
  border-color: #5764c6;
}
.card-input {
  padding: .47rem .4rem
}
.bg-secondary {
  border: 1px solid rgb(19, 110, 251,0.3);
  border-radius: 2px;
  padding: 1em;
  margin: 2em 0;
  background: rgba(63, 169, 245, 0.15);
}
.bg-secondary p {
  color: #136efb;
  margin:0;
}
.label.label-error,
.label.label-success {
  display: block
}
.btn.btn-primary {
  margin: 2em 0;
  width: 30%;
  height: 2.3rem;
}
</style>



// WEBPACK FOOTER //
// pay.vue?14334b7a